<template>
  <header>
    <div class="container">
      <div class="image" :style="{ backgroundImage: 'url(' + featuredImage + ')' }">
      </div>
      <section class="epHeader">
        <h1 v-html="episode.title"></h1>
        <div>
          <p class="meta">
            <span><span v-if="episodeNumber">{{ episodeNumber }} &bull; </span>{{ formattedPubDate }}</span>
          </p>
          <p class="actions">
            <a href="#comments">{{ comments }} Comments</a>
            <span>Share
              <a target="_blank" :href="'https://twitter.com/home?status=' + encodeURI(episode.permalink)" class="icon">
                <iconify-icon icon="fa6-brands:twitter" />
                <span class="sr-only">Twitter</span>
              </a>
              <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(episode.permalink)" class="icon">
                <iconify-icon icon="fa6-brands:facebook-f" />
                <span class="sr-only">Facebook</span>
              </a>
            </span>
          </p>
          <div class="find-podcast-in-app">
            <p>Find this episode in your podcast app here!</p>
            <div>
              <a target="_blank" rel="noopener noreferrer" href="https://pod.link/412457621" class="button is-primary is-medium">
                Subscribe
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  </header>
</template>

<script>
export default {
  name: 'hero',
  props: ['episode', 'comments'],
  computed: {
    episodeNumber () {
      if (this.episode.lstplus) {
        return 'LST+'
      } else if (this.episode.number) {
        return '#' + this.episode.number
      }
    },
    formattedPubDate () {
      let vm = this
      return vm.$moment(vm.episode.date).format('MM.DD.YY')
    },
    featuredImage () {
      let vm = this
      let image = vm.episode.image.large
      if (process.env.NODE_ENV === 'development') {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
      }
      return image
    }
  },
  methods: {
    download () {
      let vm = this
      vm.$ga.event('episode', 'download', vm.episode.slug)
    }
  }
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

header
  .container
    +smDesktop
      display: flex
      align-items: flex-end
    +desktop
      align-items: center
    .image
      background-size: cover
      background-position: 50% 0
      margin-right: 85px
      position: relative
      display: flex
      align-items: center
      justify-content: center
      width: 100%
      height: 0
      padding-bottom: 60%
      +tablet
        justify-content: flex-end
      +smDesktop
        width: 548px
        height: calc(548px * 0.6)
        padding-bottom: 0
      +desktop
        width: 636px
        height: calc(636px * 0.6)

    .epHeader
      flex: 1
      position: relative
      margin-bottom: 12px
      +smDesktop
        padding-left: 0
        padding-right: 30px
      +desktop
        padding-left: 30px
        padding-right: 0
        margin-bottom: 0
      h1
        font-size: 36px
        font-weight: bold
        margin-bottom: 0
        line-height: 38px
        margin-top: 24px
        margin-bottom: 15px
        +tablet
          display: flex
          align-items: center
          margin-top: 32px
          margin-bottom: 20px
        +smDesktop
          margin-top: 50px
      > div
        font-weight: bold
        width: 100%
        +smDesktop          
          padding-right: 30px
          margin-top: 4px
        +desktop
          padding-right: 0
        .meta, .actions
          display: flex
          justify-content: space-between
          font-size: 18px
          margin: 0
          padding: 7px 0
          letter-spacing: 0.5px
          +tablet
            padding: 7px 0
        .meta a
          color: inherit
          &:hover
            color: lighten($textColor, 25%)
        .actions
          border-top: 1px solid #95989A
          border-bottom: 1px solid #95989A
          font-size: 16px
          > a
            color: inherit
            &:hover
              svg path
                fill: $textColor
          .icon
            margin-left: 3px

.find-podcast-in-app
  margin-bottom: 20px;
  p
    font-weight: 300
    margin: 0.75em 0
    +tablet
      font-size: 18px
  .button
    color: $textColor

.podcast-app-buttons
  display: flex
  align-items: center
  a
    display: flex
    align-items: center
    justify-content: center
    background: #5CCABC
    width: 45px
    height: 45px
    transition: background 200ms
    border-radius: 10px
    font-size: 26px
    color: #49484A
    &:not(:last-child)
      margin-right: 13px
    &:hover
      background: #429F95
      

</style>



// WEBPACK FOOTER //
// Hero.vue?3af1674d